module.exports = __webpack_public_path__ + "assets/img/C-30aa75f8.png";